<template>
  <transition name="modal">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </transition>
</template>

<style src="./css/loading.css"></style>

<script>
export default {
  name: "Loading"
};
</script>
